var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"loader",style:({ width: _vm.size, height: _vm.size, '--loader-border-color': _vm.color})})
}
var staticRenderFns = []

export { render, staticRenderFns }